import { render } from "./ScreenOne.vue?vue&type=template&id=094522aa&scoped=true"
import script from "./ScreenOne.vue?vue&type=script&lang=js"
export * from "./ScreenOne.vue?vue&type=script&lang=js"

import "./ScreenOne.vue?vue&type=style&index=0&id=094522aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094522aa"]])

export default __exports__